import { Injectable } from '@angular/core';
import { Alphabet } from './lyssna-pa-alfabetet-caps.models';
import { ApiResponse } from '../../shared/models/api-response';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})

export class LyssnapaalfabetetcapsService {

    constructor(private http: HttpClient) {
    }

  getalphabet(reference: string) {
    return this.http.get<ApiResponse<Alphabet>>("/alphabet/" + reference);
    };
}









































































































































































































































































